const placeholderPattern = /{(.*?)}/g;

export const dictionary = (
	originalText: string,
	dictionary: object,
	defaultValue?: string,
) => {
	if (typeof originalText !== "string") return originalText;

	const text = originalText.replaceAll("{{", "{").replaceAll("}}", "}");
	const placeholders = Array.from(text.matchAll(placeholderPattern));
	return placeholders.reduce((acc, placeholder) => {
		const key = placeholder[1].trim();
		const value = dictionary[key] ?? defaultValue;
		if (value === undefined) {
			return acc;
		}
		return acc.replace(new RegExp(placeholder[0], "g"), value.toString());
	}, text);
};

export default dictionary;
